import { Injectable } from '@angular/core';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { Ng2DeviceService } from 'ng2-device-detector';
@Injectable()
export class PromotionalcodeserviceService {
  userGioLocation: UserGioLocation;
  constructor(private geoloc: geolocation, private utilserv: utilityService, private deviceService: Ng2DeviceService) {}
  getPromotionalCodeService(userGioLocation: any) {
    return this.utilserv.soapPostwithoutAction(this.getPromotionalCodeEnvelope(userGioLocation), AppSettings.shareCodeURL);
  }
  getPromotionalCodeEnvelope(userGioLocation: any) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.userGioLocation = userGioLocation;

    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                <s:Header>
                  <a:Action s:mustUnderstand="1">http://ShareSoapService/IMicroServiceShare/GetReferralLink</a:Action>
                  <a:MessageID>urn:uuid:0d7ee73e-63dc-4def-9625-2a5948610622</a:MessageID>
                  <a:ReplyTo>
                    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                  </a:ReplyTo>
                </s:Header>
                <s:Body>
                  <BaseReferralRequest xmlns="http://ShareSoapService/">
                    <Device>androidphone</Device>
                    <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                      <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                      <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                      <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                      <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                      <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                      <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                      <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                      <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                      <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
                      <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
                      <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                    </DeviceDetails>
                    <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                    <Latitude>${this.userGioLocation.latitude}</Latitude>
                    <Longitude>${this.userGioLocation.longitude}</Longitude>
                    <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService"
                     xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                    <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                      <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                  </SessionObject>
                  </BaseReferralRequest>
                </s:Body>
              </s:Envelope>`;
    return envelope;
  }

  // Send email

  sendPromotionalCodeEmailService(emailObj) {
    return this.utilserv.soapPostwithoutAction(this.sendPromotionalCodeEmailEnvelope(emailObj), AppSettings.shareCodeURL);
  }
  sendPromotionalCodeEmailEnvelope(emailObj) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    this.userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      this.userGioLocation = data;
    });
    let email = '';

    emailObj.emailList.forEach(element => {
      email += '<d4p1:string>' + element + '</d4p1:string>';
    });
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
        <s:Header>
          <a:Action s:mustUnderstand="1">http://ShareSoapService/IMicroServiceShare/SendRefralShareEmail</a:Action>
          <a:MessageID>urn:uuid:7974210d-3f95-448b-9f27-b26cb92f32d1</a:MessageID>
          <a:ReplyTo>
            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
          </a:ReplyTo>
        </s:Header>
        <s:Body>
          <RefralEmailRequest xmlns="http://ShareSoapService/">
            <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
              <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
              <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
              <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
              <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
              <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
              <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
              <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
              <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
              <d4p1:Latitude>${this.userGioLocation.latitude}</d4p1:Latitude>
              <d4p1:Longitude>${this.userGioLocation.longitude}</d4p1:Longitude>
              <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
            </DeviceDetails>
            <Emails xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                ${email}
            </Emails>
            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
            <RefralCode>${emailObj.RefralCode}</RefralCode>
            <RefralLink>${emailObj.RefralLink}</RefralLink>
            <SessionObject xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common.MicroService" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
          </SessionObject>

          </RefralEmailRequest>
        </s:Body>
      </s:Envelope>`;
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/sharedpromotionalcode/promotionalcodeservice.service.ts